import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import styled from '@/shared/styled';
import { Form, Switch, DatePicker, Input } from 'antd';
import moment from 'moment';
const Root = styled.div ``;
const FORM_ITEM_LAYOUT = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const todayRange = [moment(new Date()).startOf('day'), moment(new Date()).endOf('day')];
const lastestThreeDay = [moment().startOf('day'), moment().subtract('days', -2)];
const ranges = {
    近3天: lastestThreeDay,
    今天: todayRange,
};
class EditNewFeatureNoticeModal extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isTimeRequired: true,
        };
        this.handleChange = (checked, e) => {
            this.setState({
                isTimeRequired: checked,
            }, () => {
                this.props.form.validateFields(['timeRange'], { force: true });
            });
        };
    }
    componentDidMount() {
        const { initialValue } = this.props;
        this.setState({
            isTimeRequired: initialValue && initialValue.redpointSetting !== undefined ? initialValue.redpointSetting : true,
        });
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { form: { validateFields }, } = this.props;
            const values = yield new Promise((resolve, reject) => {
                validateFields((errs, values) => {
                    if (errs)
                        return reject(errs);
                    const notifyStartDate = values.timeRange.length ? moment(values.timeRange[0]).format('YYYY-MM-DD HH:mm:ss') : '';
                    const notifyExpireDate = values.timeRange.length ? moment(values.timeRange[1]).format('YYYY-MM-DD HH:mm:ss') : '';
                    resolve(Object.assign({}, values, { notifyStartDate,
                        notifyExpireDate }));
                });
            });
            return values;
        });
    }
    render() {
        const { className, style, form, initialValue } = this.props;
        const { getFieldDecorator } = form;
        let defaultTimeRange = [];
        if (initialValue && initialValue.notifyStartDate) {
            defaultTimeRange = [moment(initialValue.notifyStartDate), moment(initialValue.notifyExpireDate)];
        }
        return (<Root className={className} style={style}>
        <Form>
          <Form.Item label="新功能提醒" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('notifyRedPoint', {
            valuePropName: 'checked',
            initialValue: initialValue
                ? initialValue.redpointSetting
                : true,
        })(<Switch checkedChildren="开" unCheckedChildren="关" onChange={this.handleChange}/>)}
          </Form.Item>
          <Form.Item label="说明文案" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('message', {
            initialValue: initialValue ? initialValue.notifyMessage : '',
        })(<Input.TextArea />)}
          </Form.Item>
          <Form.Item label="生效时间" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('timeRange', {
            initialValue: defaultTimeRange,
            rules: [
                {
                    required: this.state.isTimeRequired,
                    message: '请选择生效时间',
                },
            ],
        })(<DatePicker.RangePicker ranges={ranges} showTime={{
            hideDisabledOptions: true,
            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
        }} format="YYYY-MM-DD HH:mm:ss" style={{ minWidth: 370 }}/>)}
          </Form.Item>
        </Form>
      </Root>);
    }
}
export default Form.create()(EditNewFeatureNoticeModal);
